import {Component, OnDestroy, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {AppService, DeliveryDay, getStepRoute, Host, Menu, Table} from "../../../../../common";
import {Cart, DiscountEntry} from "../../../../../common";
import {DiscountConditionType, OrderMethod} from "../../../../../common";

@Component({
    selector: 'choose-time',
    standalone: false,
    templateUrl: './choose-time.html',
    styleUrls: ['./choose-time.scss']
})
export class ChooseTimePage implements OnInit, OnDestroy {

    host: Host;
    menu: Menu;
    cart: Cart;
    table: Table;
    OrderMethod = OrderMethod;
    form: FormGroup;
    preorder_times: Array<DeliveryDay>;
    slots: Array<number>;
    discounts: Array<DiscountEntry>;
    mode: string;

    private subscriptions: Array<Subscription> = new Array<Subscription>();

    constructor(
        private router: Router,
        private location: Location,
        private appService: AppService,
        private formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.subscriptions.push(
            this.appService.load().subscribe(({host, menu, cart, table}) => {
                this.host = host;
                this.menu = menu;
                this.cart = cart;
                this.table = table;
                const total = cart.getNetTotal();
                // init discounts
                this.discounts =
                    host.discounts.filter(d => d.hasConditionType(DiscountConditionType.Time))
                        .map(d=>new DiscountEntry(cart, d, d.getAmount(cart, total), 0));

                // init possible times
                this.preorder_times = this.cart.getPreorderDays();
                // determine initial day and time
                let day = this.preorder_times[0]?.day,
                    time = this.preorder_times[0]?.times[0];
                const initial = this.cart.getDeliveryTime();
                if (initial.time) {
                    day = initial.day
                    time = initial.time
                }
                this.slots = this.getSlots(day);
                // init the form
                this.form = this.formBuilder.group({
                    day: [day],
                    time: [time],
                });
                // set method
                if (cart.desired_time == 0) {
                    this.mode = 'asap'
                } else {
                    this.mode = 'preorder'
                }
                // subscribe to day changes
                this.subscriptions.push(
                    this.form.get('day').valueChanges.subscribe((day) => {
                        this.slots = this.getSlots(day);
                        this.form.get('time').setValue(this.slots[0]);
                    })
                );
            })
        );
    }

    getSlots(day: number): Array<number>  {
        return this.preorder_times.find(e=>e.day == day)?.times;
    }

    setMode(mode: string) {
        this.mode = mode;
        return false;
    }

    ngOnDestroy(): void {
        let sub = null;
        while(sub = this.subscriptions.pop()) {
            sub.unsubscribe();
        }
    }

    canProceed() {
        return true;
    }

    onFormSubmit() {
        if (this.form.valid) {
            this.cart.desired_time = this.form.value.day + this.form.value.time;
            this.next();
        }
    }

    back() {
        this.location.back()
    }

    getNextStep() {
        return this.cart.getNextCheckoutStep();
    }

    next() {
        if (this.canProceed()) {
            if (this.mode == 'asap') {
                this.cart.desired_time = 0;
            } else {
                this.cart.desired_time = this.form.value.day + this.form.value.time;
            }
            this.cart.save();
            this.router.navigate(getStepRoute(this.getNextStep()))
        }
    }
}
